let mediaQuery = window.matchMedia('(max-width: 767px)');
let dropdownLinks = document.querySelectorAll<HTMLAnchorElement>('#header .nav li a');

const handleDropdownLinks = () => {
  if (mediaQuery.matches) {
    dropdownLinks.forEach((link) => {
      const parent = link.parentElement;
      if (parent?.classList.contains('dropdown')) {
        parent.classList.remove('dropdown');
        link.classList.remove('dropdown-toggle');
      }
      link.addEventListener('click', dropdownClickHandler);
    });
  } else {
    dropdownLinks.forEach((link) => {
      const parent = link.parentElement;
      if (!parent?.classList.contains('dropdown')) {
        parent?.classList.add('dropdown');
        link.classList.add('dropdown-toggle');
      }
      link.removeEventListener('click', dropdownClickHandler);
    });
  }
}

const dropdownClickHandler = (e: Event) => {
  const link = e.currentTarget as HTMLAnchorElement;
  const nextElement = link.nextElementSibling as HTMLElement;
  const dropdownTrigger = link.querySelector('.dropdown-trigger') as HTMLElement;

  if (!nextElement || !nextElement.classList.contains('dropdown-menu')) {
    return;
  }

  if (e.target !== dropdownTrigger) {
    return;
  }

  e.preventDefault();
  nextElement.style.display = nextElement.style.display === 'block' ? 'none' : 'block';
  dropdownTrigger.classList.toggle('fa-caret-down');
  dropdownTrigger.classList.toggle('fa-caret-up');
}

document.addEventListener('DOMContentLoaded', handleDropdownLinks);
mediaQuery.addEventListener('change', (e) => {
  handleDropdownLinks();
});

